import {Column, Entity, PrimaryColumn, PrimaryGeneratedColumn} from "typeorm";

@Entity("tipomarcacao")
export class TipoMarcacao {
  @PrimaryGeneratedColumn("uuid")
  id?: string
  @Column()
  nome?: string
  @Column()
  descricao?: string
  @Column()
  excluido?: boolean
}
